const LOCALES = { CAD: "en-CA", USD: "en-US", INR: "en-IN", GBP: "en-GB", EUR: "de-DE", AUD: "en-AU" };
export const CURRENCIES = Object.keys(LOCALES);

export const money = (v, cur = "CAD") => {
  if (typeof v === "string") return v;
  if (v === null || v === undefined) return "-";
  return new Intl.NumberFormat(LOCALES[cur] || "en-CA", { style: "currency", currency: cur, currencyDisplay: "narrowSymbol", maximumFractionDigits: 0 }).format(Number(v) || 0);
};

export const compact = (v, cur = "CAD") => money(v, cur);

export const axisShort = (v, cur = "CAD") => new Intl.NumberFormat(LOCALES[cur] || "en-CA", { style: "currency", currency: cur, currencyDisplay: "narrowSymbol", notation: "compact", maximumFractionDigits: 0 }).format(Number(v) || 0);

export const whole = (v) => (typeof v === "number" ? (Math.round(v) || 0).toLocaleString("en-US") : v);

export const pct = (v, d = 0) => `${((Number(v) || 0) * 100).toFixed(d)}%`;
